"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _Notifications = require("../../Notifications"),
    _Warning = _interopRequireDefault(require("./Warning"));

require("../styles/_delete-confirmation-modal.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var DeleteConfirmationModal = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.clearInput = function () {
      a.setState({
        deleteConfirmText: ""
      });
    }, a.updateConfirmText = function (b) {
      var c = b.target.value;
      a.setState({
        deleteConfirmText: c
      });
    }, a.handleDelete = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b() {
      var c, d, e, f, g, h, i;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              if (c = a.props, d = c.onDelete, e = c.objectId, f = c.onComplete, e) {
                b.next = 3;
                break;
              }

              return b.abrupt("return");

            case 3:
              return b.next = 5, d(e);

            case 5:
              if (g = b.sent, h = g.data, i = g.error, h && !i) {
                b.next = 11;
                break;
              }

              return (0, _Notifications.notify)({
                type: "error",
                content: "Something went wrong"
              }), b.abrupt("return");

            case 11:
              f();

            case 12:
            case "end":
              return b.stop();
          }
        }
      }, b);
    })), a.state = {
      deleteConfirmText: ""
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = this.props.objectId;
      a.objectId && !b && this.clearInput();
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.hideModal,
          c = a.objectId,
          d = a.title,
          e = a.warnings,
          f = a.children,
          g = this.state.deleteConfirmText,
          h = "delete" === g.trim().toLowerCase();
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("delete-confirmation-modal", {
          "delete-confirmation-modal--disabled": !h
        })
      }, _react["default"].createElement(_uiKit.FormModal, {
        visible: !!c,
        title: d,
        saveText: "Delete",
        onClose: b,
        saveDisabled: !h,
        onSave: this.handleDelete,
        stayOpenOnSave: !0
      }, f, _react["default"].createElement(_uiKit.Text, {
        className: "delete-confirmation-modal__warning"
      }, "Warning: This action cannot be undone!"), e && _react["default"].createElement("div", {
        className: "delete-confirmation-modal__warnings"
      }, e.map(function (a) {
        return _react["default"].createElement(_Warning["default"], {
          key: a,
          text: a
        });
      })), _react["default"].createElement(_uiKit.Input, {
        label: "To confirm deletion, type 'delete' in to the field (case insensitive)",
        onChange: this.updateConfirmText,
        value: g
      })));
    }
  }]), b;
}(_react.Component),
    _default = DeleteConfirmationModal;

exports["default"] = _default;